const FromArr = [{
		title: "经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 25,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "产品线：",
		inputtype: "selectMultiple",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 65,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "年度：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 80,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "成立日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		widthLeft: 150,
		widthRight: 150,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 38,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 80,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
];
export default FromArr;